import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  wrapper: {
    transition: 'padding-bottom 0.3s ease',
  },
  rate: {
    marginLeft: 0,
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(4, 0, 4, 0),
    },
  },
  text: {
    margin: theme.spacing(-1, 0, -1, 0),
  },
}))
